module.exports = __webpack_public_path__ + "assets/img/creative-portfolio.ca658925.png";